var map = {
	"./二维运算.svg": "+eF0",
	"./制表函数.svg": "2Qog",
	"./基础运算.svg": "xceP",
	"./引用数据.svg": "wJ5j",
	"./数值变化.svg": "tU+q",
	"./数据变形.svg": "OEmF",
	"./数据归一.svg": "yZai",
	"./累加运算.svg": "fMMP",
	"./金融经济.svg": "mlTe"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bLk8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/functionFonts ^\.\/.*\.svg$
// module id = bLk8
// module chunks = 44